<template>
    <el-dialog  v-model="isShow" :close-on-click-modal="!data.closeModal" :title="data.title" :width="data.width||'30%'" draggable @close="clickClose">
        <pre v-if="data.tips" style="margin: 25px">{{data.tips}}</pre>
        <slot name="content" :aa="22"></slot>
        <template #footer v-if="!data.footer">
            <span class="dialog-footer">
                <el-button @click="clickClose" >{{data.cancel||'取消'}}</el-button>
                <el-button type="primary" @click="debouncedClickLoginOut" :loading="confirmLoading">{{data.confirm||'确定'}}</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script lang="ts" setup>
import {ref} from 'vue'
import { debounce } from 'lodash'
    
    interface Data {
        title: string
        tips: string
        cancel: string
        confirm: string
        width:string
        type:string
        closeModal:boolean
        footer?: boolean
    }
    const props = defineProps({
        data:Object,
    })

    const emit = defineEmits(['callback'])
    let data = props.data as Data || {
        title: '',
        closeModal: true,
    }
    let isShow = ref(false)
    let confirmLoading = ref(false)


    function clickLoginOut(){
        if (data.type === 'payNew' || data.type === 'sureNew') {
            confirmLoading.value = true
            setTimeout(() => {
                emit('callback', { name: 'confirm', type: data.type })
                confirmLoading.value = false
            }, 300)
        }else{
            emit('callback',{name:'confirm',type:data.type})
        }
    }
    const debouncedClickLoginOut = debounce(clickLoginOut, 500)
    function clickClose(){
        emit('callback',{name:'close',type:data.type})
    }
    function show(v:any){
        if(v)data = v
        isShow.value = true
    }
    function close(){
        isShow.value = false
        confirmLoading.value = false
    }
    defineExpose({show,close})
</script>